import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Box, Title, Text, Button, Table } from '@mantine/core'
import { updateCurrentExperience } from '../services/actions/userActions'
import { setCurrentExperience } from '../services/store/userSlice'

const HomePage = () => {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const currentExperience = useSelector((state) => state.user.currentExperience)
	const user = useSelector((state) => state.user.authUser)
	const position = useSelector((state) => state.user.position)

	if (currentExperience?.slug) {
		navigate(`/experiences/${currentExperience.slug}`)
		return null
	}

	const handleSetExperience = async (experienceId) => {
		try {
			await updateCurrentExperience(experienceId)

			dispatch(
				setCurrentExperience({
					id: experienceId,
					slug: position.experience.slug,
					name: position.experience.name,
				})
			)

			navigate(`/${position.experience.slug}`)
		} catch (err) {
			console.error('❌ Failed to set current experience:', err)
		}
	}

	return (
		<Box px='md' py='md'>
			<Title order={2}>No Experience Assigned</Title>
			<Text mt='sm'>
				You are not currently assigned to an experience. Please contact an
				administrator if you think this is a mistake.
			</Text>

			{position?.experience && (
				<Box mt='xl'>
					<Title order={4} mb='sm'>
						Available Position
					</Title>

					<Table withBorder>
						<thead>
							<tr>
								<th>Experience Name</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr key={position.experience.id}>
								<td>{position.experience.name}</td>
								<td>
									<Button
										variant='light'
										size='xs'
										onClick={() => handleSetExperience(position.experience.id)}
									>
										Make Current Experience
									</Button>
								</td>
							</tr>
						</tbody>
					</Table>
				</Box>
			)}
		</Box>
	)
}

export default HomePage
